import { API } from "aws-amplify";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";

export const GET_METER_PROFILES_DOWNLOAD_TEMPLATE_REQUEST =
  "@@meterProfiles/GET_METER_PROFILES_DOWNLOAD_TEMPLATE_REQUEST";
export const GET_METER_PROFILES_DOWNLOAD_TEMPLATE_SUCCESS =
  "@@meterProfiles/GET_METER_PROFILES_DOWNLOAD_TEMPLATE_SUCCESS";
export const GET_METER_PROFILES_DOWNLOAD_TEMPLATE_FAILURE =
  "@@meterProfiles/GET_METER_PROFILES_DOWNLOAD_TEMPLATE_FAILURE";

export function getMeterProfilesDownloadTemplate(
  id = "",
  organisation,
  sample_table = true
) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_METER_PROFILES_DOWNLOAD_TEMPLATE_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_asset_intervals_new&organisation=${organisation}&sample_table=${sample_table}`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_METER_PROFILES_DOWNLOAD_TEMPLATE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_METER_PROFILES_DOWNLOAD_TEMPLATE_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_METER_PROFILES_LIST_REQUEST =
  "@@meterProfiles/GET_METER_PROFILES_LIST_REQUEST";
export const GET_METER_PROFILES_LIST_SUCCESS =
  "@@meterProfiles/GET_METER_PROFILES_LIST_SUCCESS";
export const GET_METER_PROFILES_LIST_FAILURE =
  "@@meterProfiles/GET_METER_PROFILES_LIST_FAILURE";

export function getMeterProfilesList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_METER_PROFILES_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_asset_intervals_new&organisation=${organisation}&sample_table=false`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_METER_PROFILES_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_METER_PROFILES_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const DELETE_METER_PROFILES_LIST_REQUEST =
  "@@meterProfiles/DELETE_METER_PROFILES_LIST_REQUEST";
export const DELETE_METER_PROFILES_LIST_SUCCESS =
  "@@meterProfiles/DELETE_METER_PROFILES_LIST_SUCCESS";
export const DELETE_METER_PROFILES_LIST_FAILURE =
  "@@meterProfiles/DELETE_METER_PROFILES_LIST_FAILURE";

export function deleteMeterProfilesList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: DELETE_METER_PROFILES_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_asset_intervals_new&organisation=${organisation}`;
      }

      const response = await API.del("usimAPI", url);
      dispatch({
        type: DELETE_METER_PROFILES_LIST_SUCCESS,
        payload: response,
      });
      dispatch(getMeterProfilesList(id, organisation));
    } catch (error) {
      dispatch({
        type: DELETE_METER_PROFILES_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const UPLOAD_METER_PROFILES_DATA_REQUEST =
  "@@meterProfiles/UPLOAD_METER_PROFILES_DATA_REQUEST";
export const UPLOAD_METER_PROFILES_DATA_SUCCESS =
  "@@meterProfiles/UPLOAD_METER_PROFILES_DATA_SUCCESS";
export const UPLOAD_METER_PROFILES_DATA_FAILURE =
  "@@meterProfiles/UPLOAD_METER_PROFILES_DATA_FAILURE";

export function uploadMeterProfilesData(
  id = "",
  organisation,
  file,
  columnMappings,
  callback
) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: UPLOAD_METER_PROFILES_DATA_REQUEST,
    });
    try {
      let url = "/presignedurl";
      if (id) {
        url = `${url}?project_id=${id}&table_name=in_asset_intervals_new`;
      }

      if (!isEmpty(columnMappings)) {
        url = `${url}&column_mappings=${encodeURI(
          JSON.stringify(columnMappings)
        )}`;
      }

      const response = await API.get("usimAPI", url);

      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/gzip" },
        body: file,
      };
      await fetch(response.uploadURL, requestOptions).then((response) => {
        if (response.status === 200) {
          toast.success("Data uploaded successfully!");
          setTimeout(() => {
            dispatch(getMeterProfilesList(id, organisation));
          }, 2000);
          callback({
            success: true,
          });
        } else {
          dispatch({
            type: UPLOAD_METER_PROFILES_DATA_FAILURE,
            payload: {
              message: "Upload data failed.",
            },
          });
        }
      });

      dispatch({
        type: UPLOAD_METER_PROFILES_DATA_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: UPLOAD_METER_PROFILES_DATA_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}
